// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__Q-aoA","myModalContent":"MyModal_myModalContent__6XNG4","active":"MyModal_active__xIrPm"};